import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainAppService } from 'src/app/services/main-app.service';

@Component({
  selector: 'app-choose-lang',
  templateUrl: './choose-lang.component.html',
  styleUrls: ['./choose-lang.component.css']
})
export class ChooseLangComponent implements OnInit {

  constructor(public mainAppService: MainAppService, public router : Router) { }

  ngOnInit(): void {
  }

  selectLang(langId: number){
    this.mainAppService.isLoading = true;
    this.mainAppService.getMainApp(langId).subscribe(mainApp => {
      this.mainAppService.isLoading = false;
      if (mainApp.responseData){
        this.mainAppService.mainApp = mainApp.responseData;
        this.router.navigateByUrl("/register")
      }
    })
  }
}
